import { apiSlice } from './apiSlice'

export interface Notification {
  id?: string
  user_id: string
  title: string
  message: string
  type: 'info' | 'warning' | 'success' | 'error'
  read: boolean
  created_at?: string
  read_at?: string
  metadata?: Record<string, any>
}

export interface NotificationCreate {
  user_id: string
  title: string
  message: string
  type?: 'info' | 'warning' | 'success' | 'error'
  metadata?: Record<string, any>
}

export interface UnreadCount {
  count: number
}

export interface WebPushConfig {
  enabled: boolean
  publicKey: string | null
  sendingEnabled: boolean
}

export interface WebPushSubscriptionPayload {
  endpoint: string
  keys: Record<string, string>
}

export const notificationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<Notification[], { unread_only?: boolean; limit?: number }>({
      query: (params) => ({
        url: '/notifications/list',
        params,
      }),
      providesTags: ['Notification'],
    }),
    getUnreadCount: builder.query<UnreadCount, void>({
      query: () => '/notifications/unread-count',
      providesTags: ['Notification'],
    }),
    getWebPushConfig: builder.query<WebPushConfig, void>({
      query: () => '/notifications/web-push/config',
    }),
    subscribeWebPush: builder.mutation<{ success: boolean; message: string }, WebPushSubscriptionPayload>({
      query: (body) => ({
        url: '/notifications/web-push/subscribe',
        method: 'POST',
        body,
      }),
    }),
    unsubscribeWebPush: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({ url: '/notifications/web-push/subscribe', method: 'DELETE' }),
    }),
    testWebPush: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({ url: '/notifications/web-push/test', method: 'POST' }),
    }),
    markAsRead: builder.mutation<{ success: boolean; message: string }, string>({
      query: (notificationId) => ({
        url: `/notifications/mark-read/${notificationId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Notification'],
    }),
    markAllAsRead: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({
        url: '/notifications/mark-all-read',
        method: 'POST',
      }),
      invalidatesTags: ['Notification'],
    }),
    deleteNotification: builder.mutation<{ success: boolean; message: string }, string>({
      query: (notificationId) => ({
        url: `/notifications/${notificationId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notification'],
    }),
  }),
})

export const {
  useGetNotificationsQuery,
  useGetUnreadCountQuery,
  useGetWebPushConfigQuery,
  useSubscribeWebPushMutation,
  useUnsubscribeWebPushMutation,
  useTestWebPushMutation,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
} = notificationsApi

